class S84Recaptcha {
    callbackName = 'g_onRecaptchaLoad';

    constructor() {

    }

    initialize(naja) {
        const that = this
        naja.addEventListener('init', this.init.bind(this))
        naja.addEventListener('complete', this.init.bind(this))
    }

    init() {
        const that = this;
        const captchas = document.getElementsByClassName('g-recaptcha');
        for (let i in captchas) {
            if (captchas.hasOwnProperty(i)) {
                let el = captchas[i]
                if (el.dataset.s84Recaptcha === 'yes') {
                    return
                }

                const form = el.closest('form');
                if (form !== null) {
                    form.addEventListener('submit', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        grecaptcha.ready(function () {
                            grecaptcha.execute(el.dataset.siteKey, {action: 'submit'}).then(function (token) {
                                // Add your logic to submit to your backend server here.
                                form.querySelector('[name="challenge"]').value = token;
                                naja.uiHandler.submitForm(form, {});
                            });
                        });
                        return false;
                    })
                }
            }
        }

        // this.createScript()
        //
        // window[this.callbackName] = function () {
        //   that.renderAll();
        // };
    }

    renderAll() {
        const els = document.getElementsByClassName('g-recaptcha')
        for (let i in els) {
            if (els.hasOwnProperty(i)) {
                let el = els[i]
                if (el.dataset.s84Recaptcha === 'yes') {
                    return
                }

                el.dataset.s84Recaptcha = 'yes'

                grecaptcha.render(el, {}, true);
            }
        }
    }

    createScript() {
        let script = document.createElement('script');

        let html = document.getElementsByTagName('html')[0];

        script.id = 's84-gr-container'
        // script.src = 'https://www.google.com/recaptcha/api.js?render=explicit&onload=' + this.callbackName + "&hl=" + (html.lang || 'en');
        script.src = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=' + (html.lang || 'en');
        script.async = true;
        script.defer = true;

        document.body.appendChild(script);
    }

    // load official library with explicit rendering
//     $('<script />', {
//     src: 'https://www.google.com/recaptcha/api.js'
// + '?onload=' + callbackName
// + '&render=explicit'
// + '&hl=' + ($('html').attr('lang') || 'en')
//
// }).insertBefore('script:first');

}

export default S84Recaptcha